import FullCalendar from '@fullcalendar/react';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import { forwardRef, useState } from 'react';
import dayjs from 'dayjs';

export const CALENDAR_LABELS_FORMAT = {
  month: 'short',
  day: 'numeric',
  weekday: 'short',
};

export const convertToDateOnly = (dateTimeString) => {
  try {
    const date = new Date(dateTimeString);

    // Check if the date is invalid (NaN)
    if (isNaN(date)) {
      throw new Error('Invalid date format');
    }

    // If the input was a valid ISO string, return the date part only
    return date.toISOString().split('T')[0];
  } catch (error) {
    console.error(`Error: ${error.message}`);
    return null; // Return null for invalid dates
  }
};

const ProjectCalendarTimeline = forwardRef(
  (
    {
      renderEventContent,
      resources,
      events,
      adjustHeight = 0,
      onDateClick,
      onChangeRangeDates,
    },
    calendarRef
  ) => {
    const [viewSettings, setViewSettings] = useState(CALENDAR_LABELS_FORMAT);

    const handleDatesSet = async (dateInfo) => {
      const today = dayjs();
      const newStartDay = dayjs(dateInfo.startStr);

      if (today.format('YYYY-MM') === newStartDay.format('YYYY-MM')) {
        setTimeout(() => {
          if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.scrollToTime({ day: today.startOf('week').date() });
          }
        }, 100);
      }

      const viewSettingsOptions =
        dateInfo?.view?.type === 'resourceTimelineWeek'
          ? null
          : CALENDAR_LABELS_FORMAT;

      setViewSettings(viewSettingsOptions);
      onChangeRangeDates({
        start_day: convertToDateOnly(dateInfo.startStr),
        end_day: convertToDateOnly(dateInfo.endStr),
      });
    };

    const handleTodayClick = () => {
      const calendarApi = calendarRef?.current?.getApi();
      setTimeout(() => calendarApi?.today(), 200);
    };

    return (
      <FullCalendar
        ref={calendarRef}
        height={window.innerHeight - adjustHeight}
        resourceAreaWidth={120}
        stickyHeaderDates
        initialView="resourceTimelineMonth"
        slotLabelFormat={viewSettings}
        plugins={[
          resourceTimelinePlugin,
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin,
        ]}
        headerToolbar={{
          left: 'prev,next myTodayBtn',
          center: '',
          right: 'title',
        }}
        buttonText={{
          today: 'TODAY',
          month: 'MONTH',
          week: 'WEEK',
          day: 'DAY',
        }}
        resources={resources}
        events={events}
        resourceAreaHeaderContent="Teams"
        editable={true}
        selectable={true}
        selectMirror={true}
        dayMaxEvents={true}
        select={onDateClick}
        eventContent={renderEventContent}
        resourceLabelContent={(e) => {
          if (e.resource._resource.parentId) return null;
          return <div>{e.resource._resource.title}</div>;
        }}
        resourceLabelClassNames={(e) => {
          if (e.resource._resource.parentId) return 'hidden';
          return 'border-top';
        }}
        datesSet={handleDatesSet}
        customButtons={{
          myTodayBtn: {
            text: 'Today',
            click: handleTodayClick,
          },
        }}
      />
    );
  }
);

export default ProjectCalendarTimeline;
